if (!customElements.get('nd-reel-previews')) {
  customElements.define('nd-reel-previews', class extends HTMLElement {
    connectedCallback() {
      if (this.observer || !('IntersectionObserver' in window)) return;
      this.visibleVideos = new Set();
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.playVisible = () => {
        this.querySelectorAll('video').forEach((video) => {
          if (document.hidden || this.motionPreference.matches || !this.visibleVideos.has(video)) {
            video.pause();
            return;
          }
          if (!video.getAttribute('src')) {
            // Start the loop where the product is clearly visible (the same
            // frame as the poster); the #t fragment covers browsers that
            // honour it, and currentTime covers the rest.
            const start = Number.parseFloat(video.dataset.start || '0') || 0;
            video.src = start > 0 ? `${video.dataset.previewSrc}#t=${start}` : video.dataset.previewSrc;
            if (start > 0) {
              video.addEventListener('loadedmetadata', () => {
                if (video.currentTime < start - 0.25 && start < (video.duration || Infinity)) video.currentTime = start;
              }, { once: true });
            }
            video.load();
          }
          video.play().catch(() => {});
        });
      };
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) this.visibleVideos.add(target);
          else this.visibleVideos.delete(target);
        });
        this.playVisible();
      }, { rootMargin: '100px 0px' });
      this.querySelectorAll('video').forEach((video) => this.observer.observe(video));
      document.addEventListener('visibilitychange', this.playVisible);
      this.motionPreference.addEventListener('change', this.playVisible);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.querySelectorAll('video').forEach((video) => video.pause());
      document.removeEventListener('visibilitychange', this.playVisible);
      this.motionPreference?.removeEventListener('change', this.playVisible);
    }
  });
}
